import { Injectable,EventEmitter,Output } from '@angular/core';
// import { Observable } from 'rxjs/Rx';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class Translate{
  public eventbus: EventEmitter<any> = new EventEmitter<any>();
  lang:string = 'jp'
  constructor(public translate:TranslateService) {

  }

  async init(): Promise<void> {
    // localStorageから保存された言語を取得
    const savedLang = localStorage.getItem('language');

    if (savedLang) {
      this.lang = savedLang;
    } else {
      const userLang = navigator.language.split('-')[0];
      this.lang = /(zh|jp)/gi.test(userLang) ? userLang : 'jp';
    }

    this.translate.setDefaultLang('jp');

    // 翻訳ファイルの読み込み完了を待つ
    await this.translate.use(this.lang).toPromise();

    // 翻訳データが実際にロードされたことを確認（テストキーで検証）
    await this.translate.get('alert.retry').toPromise();

    // localStorageに保存
    localStorage.setItem('language', this.lang);

    console.log('✅ 翻訳初期化完了 - 言語:', this.lang);
  }

  async use(lang:string = 'jp'): Promise<void> {
    await this.translate.use(lang).toPromise();
    this.lang = lang;
    // localStorageに保存
    localStorage.setItem('language', lang);
    console.log('✅ 言語変更完了:', lang);
  }

  instant(param:string){
    // paramを正しく使用
    return this.translate.instant(param);
  }

}
